<template>
  <top-nav>
    <li v-if="$can.view($store.getters.getAuthUser, 'create-bidbonds')">
      <router-link :to="{name: 'bidbonds.create'}">
        Generate a Bid Bond
      </router-link>
    </li>
    <li>
      <router-link :to="{ name: 'bidbonds.index'}">
        BidBonds
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'list-bidbond-templates')">
      <router-link :to="{name: 'bid-bond-templates.index'}">
        Templates
      </router-link>
    </li>
    <li v-if="$can.view($store.getters.getAuthUser, 'view-audit-trail')">
      <router-link :to="{name: 'bidbonds.amendments'}">
        Amendments
      </router-link>
    </li>
    <template v-if="$can.view($store.getters.getAuthUser, 'list-bidbond-pricing')">
      <li>
        <router-link :to="{name: 'bidbonds.pricing'}">
          Pricing
        </router-link>
      </li>
      <li>
        <router-link :to="{name: 'bidbonds.pricing.group'}">
          Pricing Group
        </router-link>
      </li>
    </template>
    <li>
      <router-link :to="{ name: 'counterparties.index'}">
        Counterparties
      </router-link>
    </li>
  </top-nav>
</template>
<script>
    import TopNav from "@/components/TopNav.vue";

    export default {
        components: {
            TopNav
        },
    }
</script>
